import {Box} from '@mui/material'
import {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {ActionItem} from '../../types'

import {ActionDetailsSection} from './ActionDetailsSection'

type GcbDetailsSectionProps = {
  action: ActionItem
}

export const GcbDetailsSection: FC<GcbDetailsSectionProps> = ({action}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  if (!action.costLeadership) return null

  return (
    <>
      <ActionDetailsSection
        title={t('actionDetails.kpiName')}
        value={action.kpiName ? t(`kpiName.${action.kpiName}`) : '-'}
      />
      {(action.targetCosts || action.actualCostsYtd) && (
        <Box display="flex" gap={2}>
          <Box flex={1}>
            {action.targetCosts && (
              <ActionDetailsSection
                title={t('actionDetails.targetCosts')}
                value={action.targetCosts}
              />
            )}
          </Box>
          <Box flex={1}>
            {action.actualCostsYtd && (
              <ActionDetailsSection
                title={t('actionDetails.actualCostsYtd')}
                value={action.actualCostsYtd}
              />
            )}
          </Box>
        </Box>
      )}
      {(action.targetKpi || action.actualKpiYtd) && (
        <Box display="flex" gap={2}>
          <Box flex={1}>
            {action.targetKpi && (
              <ActionDetailsSection title={t('actionDetails.targetKpi')} value={action.targetKpi} />
            )}
          </Box>
          <Box flex={1}>
            {action.actualKpiYtd && (
              <ActionDetailsSection
                title={t('actionDetails.actualKpiYtd')}
                mb={action.questionId ? 3 : 0}
                value={action.actualKpiYtd}
              />
            )}
          </Box>
        </Box>
      )}
    </>
  )
}
